export default function formatPrice(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) return "0.00";

  const negative = number < 0;
  const [coefficient, exponentText] = Math.abs(number)
    .toString()
    .toLowerCase()
    .split("e");
  const exponent = Number(exponentText || 0);
  const [integer, fraction = ""] = coefficient.split(".");
  const centDigits = integer.length + exponent + 2;
  if (centDigits <= 0) return `${negative ? "-" : ""}0.00`;

  const cents = (integer + fraction)
    .padEnd(centDigits, "0")
    .slice(0, centDigits)
    .padStart(3, "0");
  return `${negative ? "-" : ""}${cents.slice(0, -2)}.${cents.slice(-2)}`;
}
